import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import { modalService } from "@/services/modalService";

import MainLayout from "@/layouts/MainLayout.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import WinPopLayout from "@/layouts/WinPopLayout.vue";

const routes = [
  {
    path: "/",
    component: MainLayout,
    redirect: "/",
    children: [
      { //메인
        path: "/",
        name: "Main",
        component: () => import("@/views/MainPage.vue"),
      },
    ]
  },
  {
    path: "/",
    component: DefaultLayout,
    children: [
      {
        path: "/404",
        name: "404",
        component: () => import("@/views/common/404.vue"),
      },
      { //회원가입
        path: "/sign-up",
        name: "SignUp",
        component: () => import("@/views/sign-up/SignUpPage.vue"),
      },
      { //로그인
        path: "/login",
        name: "Login",
        component: () => import("@/views/login/LoginPage.vue"),
      },
      { //비밀번호 찾기
        path: "/find-pw",
        name: "FindPw",
        component: () => import("@/views/login/FindPwPage.vue"),
      },
      { //아이디 찾기
        path: "/find-id",
        name: "FindId",
        component: () => import("@/views/login/FindIdPage.vue"),
      },
      { //고객지원
        path: "/cs",
        name: "Cs",
        component: () => import("@/views/cs/CsPage.vue"),
      },
      { //1:1문의하기
        path: "/inquiry",
        name: "Inquiry",
        component: () => import("@/views/cs/Inquiry.vue"),
        meta: { authRequired: true },
      },
      { //1:1문의 상세보기
        path: "/inquiryShow",
        name: "InquiryShow",
        component: () => import("@/views/cs/InquiryShow.vue"),
        meta: { authRequired: true },
      },
      { //신용관리 소개 페이지
        path: "/credit-intro",
        name: "CreditIntro",
        component: () => import("@/views/CreditIntroPage.vue"),
      },
      { //자사신용관리 (게스트는 일부 영역 블러 노출)
        path: "/company-credit",
        name: "CompanyCredit",
        component: () => import("@/views/company-credit/CompanyCreditMainPage.vue"),
        meta: {
          authRequired: true,
          grades: ["ADMIN", "VIP", "GUEST"],
        },
      },
      { //거래처신용관리 (게스트는 일부 영역 블러 노출)
        path: "/vendor-credit",
        name: "VendorCredit",
        component: () => import("@/views/vendor-credit/VendorCreditMainPage.vue"),
        meta: {
          authRequired: true,
          grades: ["ADMIN", "VIP", "GUEST"],
        },
      },
      { //마이페이지
        path: "/mypage",
        name: "Mypage",
        component: () => import("@/views/mypage/MypagePage.vue"),
        meta: { authRequired: true }
      },
      { //유용한서비스
        path: "/service",
        name: "ServiceInfo",
        component: () => import("@/views/service/ServiceInfoPage.vue"),
      },
      { //기업 생애주기별 서비스
        path: "/lifecycle-service",
        name: "LifecycleService",
        component: () => import("@/views/service/LifecycleServicePage.vue"),
      },
    ]
  },
  {
    path: "/",
    component: WinPopLayout,
    children: [
      { //등급변동 팝업
        path: "/vendor-credit/rate-popup",
        name: "VendorCreditPopup",
        component: () => import("@/views/vendor-credit/VendorRatePopup.vue"),
        meta: {
          authRequired: true,
          grades: ["ADMIN", "VIP"],
        },
      },
      { //신용정보변동 팝업
        path: "/vendor-credit/credit-popup",
        name: "VendorCreditInfoPopup",
        component: () => import("@/views/vendor-credit/VendorCreditInfoPopup.vue"),
        meta: {
          authRequired: true,
          grades: ["ADMIN", "VIP"],
        },
      },
      { //신용정보변동 팝업
        path: "/vendor-credit/status-popup",
        name: "VendorStatusInfoPopup",
        component: () => import("@/views/vendor-credit/VendorStatusInfoPopup.vue"),
        meta: {
          authRequired: true,
          grades: ["ADMIN", "VIP"],
        },
      },
      { //자사신용관리-등급분석팝업
        path: "/company-credit-popup",
        name: "CompanyCreditPopup",
        component: () => import("@/views/company-credit/CompanyCreditPopup.vue"),
        meta: {
          authRequired: true,
          grades: ["ADMIN", "VIP"],
        },
      },
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }; // 항상 스크롤을 맨 위로 이동
  },
});

router.beforeEach((to, from, next) => {
  const isLoginRequired = to.matched.some(routeInfo => routeInfo.meta.authRequired);
  const isGradeLimited = to.matched.some(routeInfo => routeInfo.meta.grades);

  const isLogin = store.getters["userStore/isLogin"];
  if (isLoginRequired && !isLogin) {
    modalService.confirm().error({
      title: "로그인 후 이용해주세요.",
      content: "로그인이 필요한 서비스입니다.<br />지금 로그인 하시겠습니까?",
      confirmButtonText: "로그인",
      cancelButtonText: "닫기",
    }).then((result) => {
      if (result) {
        next({ name: 'Login', query: { redirect: encodeURIComponent(to.fullPath) } });
      }
    });
  } else if (isLogin && isGradeLimited) {
    const grade = store.getters["userStore/getGrade"];
    if (!to.meta.grades.includes(grade)) {
      modalService.alert().error({
        title: "지금은 이용하실 수 없습니다",
        content: "해당 서비스는 VIP 등급에서 이용할 수 있습니다.<br />지금 업그레이드해 보세요!",
      }).then(() => {
        next({ name: 'Mypage' });
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
